import React from 'react';

// Re-implmented that suffic component we used to have via a a stimjs controller.
// Trick here is to mirro rthe user entered value as a span, so it occupies the corect saace, and just color the cokmponents of the span correctly.

import { oxfordComma } from '../../lib/stringUtils';
import { cn } from '../../lib/utils';

import { inputBaseStyles, inputDefaultStyles, inputErrorStyles } from './inputStyles';

const InputWithSuffix = ({ suffix, className = '', textClassName = 'text-sm', errorMessages, value, placeholder, ...props }) => {
  const hasError = !!errorMessages;

  const messages = Array.isArray(errorMessages) ? errorMessages : [errorMessages];
  const errorText = messages
    .map((message, index) => {
      const separator = oxfordComma(index, messages.length);
      return message + separator;
    })
    .join('');

  const displayText = value || placeholder || '';

  return (
    <div className="w-full">
      <div className="relative">
        <input
          autoComplete="off"
          data-1p-ignore="true"
          value={value}
          placeholder={placeholder}
          {...props}
          className={cn(inputBaseStyles, 'pr-4', textClassName, hasError ? inputErrorStyles : inputDefaultStyles, className)}
        />
        {/* mirror span must share the input's text metrics so the suffix lands after the typed value */}
        <span
          className={cn(
            'pointer-events-none absolute inset-x-0 top-1/2 block -translate-y-1/2 truncate border border-transparent pl-4 font-blazeit',
            textClassName,
          )}
        >
          <span className="text-transparent">{displayText}</span>
          <span className="text-gray-400 dark:text-neutral-500">{suffix}</span>
        </span>
      </div>
      {hasError && <span className="mt-1 block text-left text-xs text-red-400">{errorText}</span>}
    </div>
  );
};

export default InputWithSuffix;
